'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Drawer = require('../../components/Drawer');

var _actions = require('../../store/dialogs/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Drawer.DrawerHeader.propTypes = {
  auth: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  var auth = state.auth,
      theme = state.theme,
      locale = state.locale,
      dialogs = state.dialogs;


  return {
    auth: auth,
    theme: theme,
    locale: locale,
    dialogs: dialogs
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { setDialogIsOpen: _actions.setDialogIsOpen })(_Drawer.DrawerHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/containers/Drawer/DrawerHeader.js
// module id = 825
// module chunks = 49